import * as React from "react";
import { CommonProjectImportExportHelp } from "../../CommonComponents/CommonProjectImportExportViews";
export const ProjectImportExportTasksHelp = () => (<CommonProjectImportExportHelp>
        <p>This page displays the import and export tasks that have recently been run.</p>
    </CommonProjectImportExportHelp>);
export const ProjectImportHelp = () => (<CommonProjectImportExportHelp>
        <p>Import project/s from either an exported zip file, or from an export task in another space on the same Octopus instance.</p>
    </CommonProjectImportExportHelp>);
export const ProjectExportHelp = () => (<CommonProjectImportExportHelp>
        <p>Select the project/s you wish to export, and enter a password which will be used to protect the exported zip file.</p>
    </CommonProjectImportExportHelp>);
